<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     商城管理-商品列表
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="ei-product padding-footer">

    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item">
          <el-select v-model="query.status" placeholder="商品状态" clearable filterable style="width: 160px;" @change="fetchData(1)">
            <el-option v-for="item in status" :key="item.key" :label="item.value" :value="item.key" />
          </el-select>
        </div>
        <div class="filter-item">
          <el-cascader v-model="query.catid" placeholder="选择商品类目" :options="options" :props="{ expandTrigger: 'click', checkStrictly: true }" filterable clearable @change="changeProductType"></el-cascader>
        </div>
        <div class="filter-item" style="width: 260px;">
          <div class="flex-center">
            <el-input v-model="query.min_price" placeholder="￥最小价格" clearable @change="fetchData()" />
            <span class="ml-xs mr-xs text-muted">—</span>
            <el-input v-model="query.max_price" placeholder="￥最大价格" clearable @change="fetchData()" />
          </div>
        </div>
        <div class="filter-item" style="width: 160px;">
          <el-input v-model="query.title" placeholder="商品名称" prefix-icon="el-icon-search" clearable @change="fetchData()" />
        </div>
      </div>
      <div class="toolbox">
        <el-button icon="el-icon-plus" type="success" class="mr-sm" @click="categoryShow = true">新建商品</el-button>
        <el-button icon="el-icon-setting" type="success" plain class="mr-sm" @click="setShow = true">商城设置</el-button>
        <div class="mode bg-white radius5 flex align-items-center">
          <i class="iconfont icon-list-mode text-muted" :class="{ 'text-primary': product_mode == 'list'}" role="button" @click="setMode('list')"></i>
          <i class="iconfont icon-card-mode text-muted ml-sm" :class="{ 'text-primary': product_mode == 'card'}" role="button" @click="setMode('card')"></i>
        </div>
      </div>

    </div>

    <el-card v-if="product_mode == 'list'" v-loading="loading" shadow="never" class="mb-md">
      <el-table ref="listTable" :data="list" tooltip-effect="dark" class="padding-small" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50" />
        <el-table-column width="60">
          <template slot-scope="scope">
            <f-user-avatar :src="scope.row.first_head_img" />
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="商品名称" min-width="160">
          <template slot-scope="scope">
            <el-link v-if="scope.row.edit_status != 2" :underline="false" @click="toProductDetail(scope.row)">{{ scope.row.title }}</el-link>
            <span v-else>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column width="30">
          <template slot-scope="scope">
            <span class="font-md" role="button" @click="stickHandle(scope.row)">
              <el-tooltip effect="dark" :content="scope.row.displayorder > 0 ? '取消置顶' : '置顶'" placement="top">
                <i v-if="scope.row.displayorder > 0" class="el-icon-star-on text-yellow font-md"></i>
                <i v-else class="el-icon-star-off hover-show"></i>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="价格" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.sale_price | currency }}</span>
          </template>
        </el-table-column>
        <el-table-column label="库存" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.stock_num }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销量" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.total_sold_num }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="更新时间">
          <template slot-scope="scope">
            <span>{{ scope.row.updatetime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品状态" min-width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 5" type="success">{{ '已上架' }}</el-tag>
            <el-tag v-else-if="scope.row.status == 0" type="warning">{{ '待上架' }}</el-tag>
            <el-tag v-else-if="scope.row.status == 11" type="danger">{{ '手动下架' }}</el-tag>
            <el-tooltip v-else-if="scope.row.status == 13" effect="dark" content="请联系客服处理" placement="top">
              <el-tag type="danger">{{ '违规下架' }}</el-tag>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- <el-table-column label="审核状态" min-width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.edit_status == 1" type="info">{{ '未提交' }}</el-tag>
            <el-tag v-if="scope.row.edit_status == 2" type="warning">{{ '正在审核' }}</el-tag>
            <el-tag v-if="scope.row.edit_status == 3" type="danger">{{ '审核失败' }}</el-tag>
            <el-tag v-if="scope.row.edit_status == 4" type="success">{{ '审核通过' }}</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column width="180" label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.edit_status != 2" type="text" @click="toProductDetail(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.status !== 5 && scope.row.edit_status !== 2 && scope.row.status !== 13" type="text" @click="putOnShelf(scope.row)">上架</el-button>
            <el-button v-if="scope.row.edit_status == 2" type="text" @click="resetReview(scope.row)">撤销审核</el-button>
            <el-button v-if="scope.row.status == 5 && scope.row.edit_status != 2" type="text" @click="offShelf(scope.row)">下架</el-button>
            <el-button type="text" @click="delProduct(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <template slot="append">
          
        </template>
        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt="" class="no-data">
          </div>
        </div>
      </el-table>
    </el-card>

    <div v-else class="flex" style="flex-wrap: wrap;justify-content: flex-start;">
      <template v-if="list.length">
        <div v-for="(item, index) in list" :key="index" role="button" class="bg-white radius10 mb-md mr-md product-card">
          <div class="font-lg stick" role="button" @click.stop="stickHandle(item)">
            <el-tooltip effect="dark" :content="item.displayorder > 0 ? '取消置顶' : '置顶'" placement="top">
              <i v-if="item.displayorder > 0" class="el-icon-star-on text-yellow font-md"></i>
              <i v-else class="el-icon-star-off text-white hover-show"></i>
            </el-tooltip>
          </div>
          <el-popover
            placement="bottom-end"
            width="120"
            trigger="click"
            popper-class="tool-pop"
            :visible-arrow="false">
            <div v-if="item.status !== 5 && item.edit_status !== 2 && item.status !== 13" class="pop-item pops" role="button" @click="putOnShelf(item)">上架</div>
            <div v-if="item.status == 5 && item.edit_status != 2" class="pop-item pops" role="button" @click="offShelf(item)">下架</div>
            <div v-if="item.edit_status == 2" class="pop-item pops" role="button" @click="resetReview(item)">撤销审核</div>
            <div class="pop-item pops" role="button" @click="delProduct(item)">删除</div>
            <i class="el-icon-more font-lg text-white more hover-show" slot="reference" role="button"></i>
          </el-popover>

          <el-image :src="item.first_head_img" fit="cover" class="product-img" @click="toProductDetail(item)" />
          <div class="flex column pt-sm pb-sm pl-sm pr-sm" @click="toProductDetail(item)">
            <div class="product-title">{{ item.title }}</div>
            <div class="text-warning font-lg mt-sm">{{ item.sale_price | currency }}</div>
            <div class="flex align-items-center justify-content-space-between mt-sm">
              <div class="">销量{{ item.total_sold_num }}</div>
              <div class="">库存{{ item.stock_num }}</div>
            </div>
          </div>
          <div v-if="(item.status !== 5 && item.edit_status !== 2 && item.status !== 13)" class="mask flex-center column radius10">
            <div class="removed flex-center text-white font-md text-bold">已下架</div>
          </div>
        </div>
      </template>
      
    </div>
    <div v-if="product_mode == 'card' && !list.length" class="flex-center column pb-md mt-hg">
      <div class="flex-center mt-hg">
        <img src="../../assets/no-data.png" alt="" class="no-data">
      </div>
    </div>

    <f-table-footer v-if="list.length" :list="list" :selection="multiSelection" :checkbox="product_mode == 'list' ? true : false" @toggle="toggleAll" class="main-footer-fix" style="padding-left: 38px">
      <el-button v-if="product_mode == 'list'" type="primary" size="mini" :disabled="multiSelection.length === 0" :plain="multiSelection.length === 0" @click="multiDelProduct">批量删除</el-button>
      <template slot="right">
        <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" :sizes-show="product_mode == 'list'" @change="fetchData" />
      </template>
    </f-table-footer>

    <product-category v-if="categoryShow" :show.sync="categoryShow" @change="newProduct" />

    <mall-set v-if="setShow" :show.sync="setShow" />
  </div>
</template>

<script>
import { getGodProductCategoryApi, getMallProductListApi, putOnShelfApi, putOffShelfApi, delProductApi, resetProductReviewApi, stickProductAPi, unstickProductAPi } from '@/api/ei/eiMallApi'

export default {
  name: 'EiProduct',

  components: {
    ProductCategory: () => import('./components/ProductCategory'),
    MallSet: () => import('./components/MallSet.vue')
  },

  data () {
    return {
      setShow: false,
      itemRow: {},
      categoryShow: false,
      loading: false,
      options: [],
      query: {
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        title: '',
        status: null,
        catid: null,
        min_price: null,
        max_price: null
      },
      list: [],
      status: [
        { key: 1, value: '待上架' },
        { key: 2, value: '已上架' },
        { key: 3, value: '已下架' }
      ],
      multiSelection: [],
      total: 0,
      product_mode: ''
    }
  },

  computed: {
  },

  created: function () {
    const keepAlivePath = [
      '/ei/product/detail'
    ]
    this.query = this.$utils.initListQuery(this.query, keepAlivePath)
    this.product_mode = localStorage.getItem('__PRODECT_MODE__') || 'card'

    this.fetchData()
    this.fetchCategory()
  },

  beforeRouteLeave (to, from, next) {
    this.$utils.saveListQuery(this.query)
    next()
  },

  methods: {
    toggleAll() {
      this.$refs.listTable.toggleAllSelection()
    },

    setMode(mode) {
      this.product_mode = mode
      localStorage.setItem('__PRODECT_MODE__', mode)
    },

    newProduct (catid) {
      this.$router.push({ path: '/ei/product/detail?cat_id=' + catid })
    },

    handleSelectionChange (val) {
      this.multiSelection = val
    },

    changeProductType (e) {
      // console.log(e)
      this.query.catid = e.length > 0 ? e[e.length - 1] : null
      this.fetchData(1)
    },

    fetchCategory () {
      getGodProductCategoryApi().then(res => {
        if (res.errno === 0) {
          this.options = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },

    fetchData (page) {
      if (this.product_mode == 'card') this.query.psize = 12
      if (page) this.query.pindex = page
      this.loading = true
      getMallProductListApi(this.query).then(res => {
        this.loading = false
        if (res.errno === 0) {
          this.list = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },

    toProductDetail (row) {
      if (row.edit_status != 2) this.$router.push({ path: '/ei/product/detail?productid=' + row.productid + '&cat_id=' + row.catid })
    },

    putOnShelf (item) {
      this.$confirm(`确定上架商品<span style="color:#07c160";> ${item.title}</span> ？`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        putOnShelfApi({ productid: item.productid }).then(res => {
          if (!res.errno) {
            this.$message.success('商品已上架成功！')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => { });
    },

    offShelf (item) {
      this.$confirm(`确定下架商品<span style="color:#07c160";> ${item.title} </span>？`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        putOffShelfApi({ productid: item.productid }).then(res => {
          if (!res.errno) {
            this.$message.success('商品已下架成功！')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => { });
    },

    resetReview (item) {
      this.$confirm(`请确认是否撤销正在审核的商品<span style="color:#07c160";> ${item.title}</span>？`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resetProductReviewApi({ productid: item.productid }).then(res => {
          if (!res.errno) {
            this.$message.success('撤销成功！')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => { });
    },

    delProduct (item) {
      this.$confirm(`请确认是否删除商品<span style="color:#07c160";> ${item.title}</span> ？`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        delProductApi({ productids: [item.productid] }).then(res => {
          this.loading = false
          if (!res.errno) {
            this.$message.success('删除商品成功！')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => { });
    },

    multiDelProduct () {
      let tmp = this.multiSelection.map(v => v.productid)
      this.$confirm(`请确认是否批量删除已选中商品？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        delProductApi({ productids: tmp }).then(res => {
          this.loading = false
          if (!res.errno) {
            this.$message.success('删除商品成功！')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => { });
    },

    stickHandle(row){
      let { productid } = row
      if(row.displayorder > 0){
        unstickProductAPi({ productid }).then(res=>{
          if(!res.errno) {
            this.$message.success('取消置顶成功！')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        }) 
      }else {
        stickProductAPi({ productid }).then(res=>{
          if(!res.errno) {
            this.$message.success('置顶成功！')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        }) 
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pops {
  padding: 6px 15px;
}
.mode {
  height: 36px;
  padding: 10px 10px;
  .iconfont {
    font-size: 22px;
  }
}
.product-card {
  width: 250px;
  box-shadow: 0 1px 3px rgba(0,0,0,.3);
  position: relative;
  &:hover{
    .hover-show {
      display: inline-block !important;
      transition: display .5s;
    }
  }
  .stick {
    position: absolute;
    top: 5px;
    left: 5px;
    z-index: 202;
  }
  .more {
    position: absolute;
    top: 5px;
    right: 10px;
    z-index: 202;
  }
  .product-img {
    width: 250px;
    height: 250px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .product-title {
    height: 40px;
    line-height: 1.2;
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(51, 51, 51, .6);
    z-index: 201;
    opacity: 1;
    transition: all .2s;
    .removed {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      background-color: rgba(49, 49, 49, 0.9)
    }
  }
}

</style>
